import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {ref} from 'vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'ScrollToTopButtonLite',
  setup(__props) {

const element = ref<HTMLElement>();
// When the user clicks on the button, scroll to the top of the document
function findNearestScrolledDownElement(el?: HTMLElement | null) {
  if (!el) return el;
  if (el.scrollTop > 0) return el;
  if (el.parentElement) return findNearestScrolledDownElement(el.parentElement);
  return el;
}
function topFunction() {
  findNearestScrolledDownElement(element.value?.parentElement)?.scrollTo(element.value?.parentElement?.scrollLeft ?? 0,0);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    ref_key: "element",
    ref: element,
    onClick: _cache[0] || (_cache[0] = ($event: any) => (topFunction())),
    class: "topBtn",
    "aria-label": "Go to top"
  }, "↑", 512))
}
}

})